import React from 'react';
import {
  DialogBox,
  DialogBoxBody,
  ButtonBase,
  IconClose,
  dlsBlack,
} from '@americanexpress/dls-react';
import {
  string, func, bool,
} from 'prop-types';
import Helmet from 'react-helmet';
import styles from './styles.scss';

const Recaptcha = ({
  locale,
  errorMessage,
  showRecaptchaError,
  verify,
  cancelModal,
  recaptchaSiteKey,
}) => {
  window.recaptchaVerify = verify;
  return (
    <div>
      <Helmet>
        <script src={`https://www.google.com/recaptcha/api.js?hl=${locale}`} />
      </Helmet>
      <DialogBox>
        <DialogBoxBody
          className={`
        flex
        flex-justify-between
        flex-column
        flex-align-items-center
        pad-0-tb
        margin-0-tb
        margin-auto-lr
        ${styles.modalBodyContainer}`}
        >
          <ButtonBase
            data-testid="recaptcha-close-button"
            onClick={cancelModal}
            theme={{
              position: 'absolute',
              right: '-20px',
              top: '-30px',
              padding: '0',
              minWidth: '0',
              ':focus, :active': {
                outline: 'none',
              },
            }}
          >
            <IconClose
              theme={dlsBlack}
              size="sm"
            />
          </ButtonBase>
          {showRecaptchaError && <div className="dls-accent-red-01 margin-1-b"><p>{errorMessage}</p></div>}
          <div
            data-testid="recaptcha-container"
            className="g-recaptcha"
            data-callback="recaptchaVerify"
            data-sitekey={recaptchaSiteKey}
          />
        </DialogBoxBody>
      </DialogBox>
    </div>
  );
};

Recaptcha.propTypes = {
  locale: string,
  errorMessage: string,
  verify: func,
  showRecaptchaError: bool,
  cancelModal: func,
  recaptchaSiteKey: string,
};

export default Recaptcha;
